export const TASK_ATTACHMENT_LIMIT = 5;



// WEBPACK FOOTER //
// ./src/constants/tasks.js